@use './nhs-core.scss' as *;
@use './nhs-button.scss' as *;
@use 'nhsuk-frontend/core/tools' as *;
@use './nhs-error-summary.scss' as *;
@use './nhs-radios.scss' as *;
@use './nhs-number.scss' as *;

$button-border-radius: nhsuk-spacing(2);

.nhsapp-button,
.nhsapp-button.nhsuk-button--secondary::before,
.nhsapp-button.nhsuk-button--secondary:active {
  border-radius: $button-border-radius;
}

.nhsapp-button.nhsuk-button--secondary:not(:focus)::after,
.nhsapp-button.nhsuk-button--secondary-solid:not(:focus)::after {
  border-radius: $button-border-radius - 2px !important;
}

:host {
  display: block;
}